import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.services';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrl: './blogs.component.css'
})
export class BlogsComponent implements OnInit {
  allBlogList: Array<any> = []
  constructor(private _apiService : ApiService){

    this._apiService.getBlogList().subscribe((res) => {
      this.allBlogList = res.data;
      console.log(this.allBlogList);
    });
  }

  ngOnInit(): void {
    
  }
}
